import { NgModule } from "@angular/core";
import { CheckboxFormComponent } from './checkbox-form/checkbox-form.component';
import { DynamicCheckboxComponent } from './dynamic-checkbox.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { CommonModule } from '@angular/common';
import { CheckboxDesignComponent } from './checkbox-design/checkbox-design.component';
import { CheckboxResultComponent } from './checkbox-result/checkbox-result.component';
import { KendoModule } from '../kendo.module';

@NgModule({
    declarations: [
        CheckboxDesignComponent,
        CheckboxFormComponent, DynamicCheckboxComponent, CheckboxResultComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        IonicModule,
        KendoModule
    ],
    entryComponents: [
        DynamicCheckboxComponent
    ]
})
export class CheckboxModule {}